import React, { useEffect } from "react";
import { connect } from "react-redux";
import EmployeeTable from "./components/EmployeeTable";
import DownloadButton from "components/button/download";
import UploadButton from "components/button/upload";
import { getCountryList, getClientList } from "../../../redux/optionlist/optionlistState";
import { 
  UserPlus,
  Users,
  UserMinus,
} from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import {
  getEmployeeStat
} from "../../../redux/employee/employeeState";

const Employees = ({
	getCountryOptions, 
	filters, 
	getStats, 
	recordStat,
	getClientOptions
}) => {
	
	useEffect(() => {
	    getCountryOptions({});
		getClientOptions({});
    }, [getCountryOptions, getClientOptions]);

	useEffect(() => {
		getStats();
	},[getStats]);

	return (
	    <div>
			<SummaryHeader
				title={"Employees"}
				icon={Users}
				description={"Quickly find and connect with team members"}
				color={"blue"}
			>
				<div className="summary-item-container">
					<SummaryItem
						title="Active Employees"
						icon={<UserPlus />}
						display={recordStat?.active}
					/>
					<SummaryItem
						title="Separated Employees"
						icon={<UserMinus />}
						display={recordStat?.separated}
					/>
				</div>
			</SummaryHeader>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">

	      	<EmployeeTable/>
	      	
	      	<div className="flex flex-row-reverse text-right hidden">	      		
	      		<DownloadButton downloadPath="employee-details" title="Download" filters={filters}/>
	      		<UploadButton uploadPath="employee-details" title="Upload"/>
	      	</div>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  filters: state.employee.employeeList?.filters,
  recordStat: state.employee.employeeStat.data,
});

const mapDispatchToProps = (dispatch) => ({
  getCountryOptions: (filters) => dispatch(getCountryList(filters)),
  getClientOptions: (filters) => dispatch(getClientList(filters)),
  getStats: (data) => dispatch(getEmployeeStat(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Employees);